import { useState } from 'react';
import { countAdmins, setAdminStatus, updateMusician, updateVenue, setVenueEquipment } from '../lib/supabase';
import { sortRolesByLevel } from '../helpers';
import { LEVEL_LABELS } from '../constants';
import { PRIVACY_POLICY, TERMS_CONDITIONS } from '../legal';
import ProfileEditModal from '../modals/ProfileEditModal';
import VenueEditModal from '../modals/VenueEditModal';
import VenuesList from './VenuesList';
import Modal from '../ui/Modal';
import FotoIntera from '../ui/FotoIntera';
import { PulsanteHome } from '../ui/MettiSullaHome';
function ProfileView({ user, venues, venueEquipment, onLogout, onUserUpdate, onDeleteSelf, onRefresh }) {
  const isMusicianAccount=user.accountType==="musician";
  const [confirmResign,setConfirmResign]=useState(false); const [confirmDelete,setConfirmDelete]=useState(false);
  const [showEdit,setShowEdit]=useState(false); const [loading,setLoading]=useState(false); const [error,setError]=useState("");
  const [fullscreen,setFullscreen]=useState(false);
  const [showLegalDoc,setShowLegalDoc]=useState(null); // 'terms' | 'privacy' | null
  const [erroreCancella,setErroreCancella]=useState("");
  const handleResignAdmin=async()=>{
    setError("");setLoading(true);
    try{const c=await countAdmins();if(c<=1){setError("Sei l'unico amministratore.");setConfirmResign(false);return;}const u=await setAdminStatus(user.id,false);onUserUpdate(u);setConfirmResign(false);}
    catch{setError("Errore.");}finally{setLoading(false);}
  };
  const levels=user.levels||{};
  const allRoles=sortRolesByLevel(user.instruments||[], user.sings, levels);
  return (
    <div className="fade-up">
      <div style={{fontSize:26,fontWeight:800,color:"var(--text)",lineHeight:1.1,marginBottom:18}}>Profilo</div>
      <div className="card">
        <div style={{display:"flex",alignItems:"center",gap:14,marginBottom:16}}>
          {user.avatar_url
            ? <img src={user.avatar_url} alt="" onClick={()=>setFullscreen(true)}
                style={{width:80,height:80,borderRadius:'50%',objectFit:'cover',flexShrink:0,cursor:'pointer'}}/>
            : <div className="avatar" style={{width:80,height:80,fontSize:28}}>{user.name.charAt(0)}</div>
          }
          {fullscreen && <FotoIntera src={user.avatar_url} onClose={() => setFullscreen(false)}/>}
          <div style={{flex:1}}>
            <div style={{fontWeight:800,fontSize:20,display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
              {user.name}{user.is_admin&&<span className="badge-admin">ADMIN</span>}
            </div>
            <div style={{color:"var(--muted)",fontSize:16}}>{user.email}</div>
          </div>
          <button className="btn btn-secondary btn-sm" onClick={()=>setShowEdit(true)}>Modifica</button>
        </div>
        {isMusicianAccount&&<>
          {(user.phone||user.whatsapp_link)&&<div style={{display:"flex",gap:12,marginBottom:12}}>
            {user.phone&&<span style={{fontSize:16,color:"var(--muted)"}}>{user.phone}</span>}
            {user.whatsapp_link&&<a href={user.whatsapp_link} target="_blank" rel="noreferrer" style={{fontSize:16,color:"var(--text)"}}>WhatsApp</a>}
          </div>}
          {allRoles.length>0&&<div style={{marginBottom:12}}>
            <div className="form-label" style={{marginBottom:8}}>Strumenti</div>
            <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
              {allRoles.map(r=>(
                <div key={r} style={{display:"inline-flex",alignItems:"center",gap:8,
                  background:"rgba(237,77,29,0.08)",border:"1px solid rgba(237,77,29,0.2)",
                  borderRadius:10,padding:"8px 14px"}}>
                  <span style={{fontSize:17,fontWeight:700,color:"var(--text)"}}>{r}</span>
                  {levels[r]>0&&<span style={{fontSize:16,color:"var(--muted)",borderLeft:"1px solid rgba(255,255,255,0.1)",paddingLeft:8}}>{LEVEL_LABELS[levels[r]]}</span>}
                </div>
              ))}
            </div>
          </div>}
          {(user.genres||[]).length>0&&<div className="chip-group" style={{marginBottom:10}}>{user.genres.map(g=><span key={g} className="chip genre">{g}</span>)}</div>}
        </>}
        <hr className="divider"/>
        {user.is_admin&&<div style={{marginBottom:14}}>
          {error&&<div className="alert alert-error" style={{marginBottom:8}}>{error}</div>}
          {!confirmResign
            ?<div style={{background:"rgba(255,71,87,.05)",border:"1px solid rgba(255,71,87,.2)",borderRadius:10,padding:"12px 14px"}}>
              <div style={{fontSize:16,color:"var(--muted)",marginBottom:8}}>Sei amministratore. Puoi rinunciare se esiste almeno un altro admin.</div>
              <button className="btn btn-danger btn-sm" onClick={()=>setConfirmResign(true)}>Rinuncia al ruolo Admin</button>
            </div>
            :<div style={{background:"rgba(255,71,87,.08)",border:"1px solid rgba(255,71,87,.35)",borderRadius:10,padding:"12px 14px"}}>
              <div style={{fontWeight:700,fontSize:16,marginBottom:5}}>Sei sicuro?</div>
              <div style={{display:"flex",gap:7}}>
                <button className="btn btn-secondary btn-sm" onClick={()=>setConfirmResign(false)}>Annulla</button>
                <button className="btn btn-danger btn-sm" disabled={loading} onClick={handleResignAdmin}>{loading?<span className="spinner"/>:"Sì, rinuncio"}</button>
              </div>
            </div>}
          <hr className="divider"/>
        </div>}
        <PulsanteHome style={{marginBottom:12}}/>
        <button className="btn btn-secondary btn-sm" onClick={onLogout} style={{width:"100%",justifyContent:"center"}}>
          Esci
        </button>
        <div style={{marginTop:20,paddingTop:16,borderTop:"1px solid var(--border)",textAlign:"center",display:"flex",justifyContent:"center",gap:20,marginBottom:8}}>
          <button style={{background:"none",border:"none",cursor:"pointer",fontSize:16,color:"var(--muted2)",textDecoration:"underline"}}
            onClick={()=>setShowLegalDoc('terms')}>Termini e Condizioni</button>
          <button style={{background:"none",border:"none",cursor:"pointer",fontSize:16,color:"var(--muted2)",textDecoration:"underline"}}
            onClick={()=>setShowLegalDoc('privacy')}>Informativa Privacy</button>
        </div>
        <div style={{marginTop:8,paddingTop:16,borderTop:"1px solid var(--border)",textAlign:"center"}}>
          {!confirmDelete
            ?<button style={{background:"none",border:"none",cursor:"pointer",fontSize:16,color:"var(--muted2)",textDecoration:"underline"}}
                onClick={()=>setConfirmDelete(true)}>Cancella account</button>
            :<div style={{background:"rgba(160,80,80,0.08)",border:"1px solid rgba(160,80,80,0.2)",borderRadius:10,padding:"14px"}}>
              <div style={{fontSize:16,color:"var(--text)",marginBottom:12}}>Eliminare definitivamente il tuo account?</div>
              <div style={{display:"flex",gap:8,justifyContent:"center"}}>
                <button className="btn btn-secondary btn-sm" onClick={()=>setConfirmDelete(false)}>Annulla</button>
                <button className="btn btn-danger btn-sm" disabled={loading} onClick={async()=>{
                  setErroreCancella("");setLoading(true);
                  try{ await onDeleteSelf(); }
                  catch(e){
                    console.error(e);
                    setErroreCancella((e?.message||"").includes("ULTIMO_ADMIN")
                      ?"Sei l'unico amministratore di Jammo: prima di cancellarti, nomina un altro amministratore dalla pagina Musicisti."
                      :"Non sono riuscito a cancellare l'account. Riprova tra poco.");
                    setConfirmDelete(false);
                  }
                  finally{ setLoading(false); }
                }}>Sì, elimina</button>
              </div>
            </div>}
          {erroreCancella&&<div className="alert alert-error" style={{marginTop:12,textAlign:"left"}}>{erroreCancella}</div>}
        </div>
      </div>
      {showLegalDoc&&<Modal onClose={()=>setShowLegalDoc(null)}>
        <div className="modal-title">{showLegalDoc==='terms'?'Termini e Condizioni':'Informativa Privacy'}</div>
        <div style={{maxHeight:"60vh",overflowY:"auto",background:"var(--surface2)",borderRadius:10,padding:"14px 16px",border:"1px solid var(--border)"}}>
          <pre style={{whiteSpace:"pre-wrap",wordBreak:"break-word",fontSize:16,color:"var(--muted)",lineHeight:1.7,margin:0,fontFamily:"inherit"}}>
            {showLegalDoc==='terms'?TERMS_CONDITIONS:PRIVACY_POLICY}
          </pre>
        </div>
        <div style={{marginTop:14,textAlign:"center"}}>
          <button className="btn btn-secondary btn-sm" onClick={()=>setShowLegalDoc(null)}>Chiudi</button>
        </div>
      </Modal>}
      {showEdit&&isMusicianAccount&&<ProfileEditModal musician={user} onClose={()=>setShowEdit(false)}
        onSave={async(data)=>{const u=await updateMusician(user.id,data);onUserUpdate({...u,accountType:"musician"});}}/>}
      {showEdit&&!isMusicianAccount&&<VenueEditModal venue={{...user,_equipment:[]}} title="Modifica location" onClose={()=>setShowEdit(false)}
        onSave={async(data,equipment)=>{const v=await updateVenue(user.id,data);await setVenueEquipment(v.id,equipment.map(item=>({item})));onUserUpdate({...v,accountType:"venue"});}}/>}

      {/* Sezione Locations per admin */}
      {user.is_admin&&venues&&<div style={{marginTop:24}}>
        <VenuesList venues={venues} venueEquipment={venueEquipment||{}} currentUser={user} onRefresh={onRefresh||(() => {})}/>
      </div>}
    </div>
  );
}


export default ProfileView;
